module.exports = __webpack_public_path__ + "static/img/icon_license_expire.e3575985.png";